export const mapBucketCapacities = data => {
  return {
    copilot: data.sku_capacity_explore_accessories ?? 20,
    m365: data.sku_capacity_microsoft365 ?? 20,
    explore: data.sku_capacity_explore ?? 20,
    gaming: data.sku_capacity_game_pass ?? 100,
    devices: data.sku_capacity_devices ?? 50,
  };
};
